import React, { useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import DropDown from '../Ui/DropDown';

const ChildProcessCostModal = ({ t, type, childData, showModal, moduleTypeOptions, moduleGroupOptions, handleOk, handleCancel }) => {
    const [attributeName, setAttributeName] = useState('');
    const [moduleType, setModuleType] = useState('');
    const [moduleGroup, setModuleGroup] = useState('');
    const [costAmount, setCostAmount] = useState(0);
    const [childID, setChildID] = useState(0);

    useEffect(() => {
        if (childData != null && childData != 'undefined' && Object.keys(childData).length !== 0) {
            setChildID(childData.id);
            setAttributeName(childData.attributeName);
            setModuleType(childData.moduleType);
            setModuleGroup(childData.moduleGroup);
            setCostAmount(childData.costAmount);
        }
    }, [childData]);

    const handleDisableAddCTA = () => {
        return (attributeName === '') || !(moduleType.value === 'AAMER_ENTITY' ? costAmount >= 0 : costAmount > 0) || !moduleType.value || !moduleGroup.value;
    };

    const handleChildPCData = () => {
        handleOk(attributeName, costAmount, moduleType, moduleGroup, childID);
    };

    return (
        <div>
            <div className="modal" style={{ display: (showModal ? 'block' : '') }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{(type === 'edit') ? t("mastersManagement.processCost.editChildProcessCost") : t("mastersManagement.processCost.addChildProcessCost")}</h5>
                            <button type="button" className="d-flex close border-0 rounded-2 p-1" aria-label="Close" onClick={handleCancel}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.processCost.attributeName")}</label>
                                <input placeholder={t("mastersManagement.processCost.attributeNamePlaceholder")} type="text" className="form-control"
                                    name="Attribute Name" value={attributeName} onChange={e => setAttributeName(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.processCost.costAmount")}</label>
                                <input placeholder={t("mastersManagement.processCost.costAmountPlaceholder")} type="number" className="form-control"
                                    name="Cost Amount" value={costAmount} onChange={e => setCostAmount(parseFloat(e.target.value))} />
                            </div>
                            <DropDown label={t("mastersManagement.processCost.moduleType")} placeholder={t("mastersManagement.processCost.moduleTypePlaceholder")} options={moduleTypeOptions} value={moduleType} onChange={(value) => setModuleType(value)} />
                            <DropDown label={t("mastersManagement.processCost.moduleGroup")} placeholder={t("mastersManagement.processCost.moduleGroupPlaceholder")} options={moduleGroupOptions} value={moduleGroup} onChange={(value) => setModuleGroup(value)} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{t("sideNav.newJobRequest.close")}</button>
                            <button type="button" disabled={handleDisableAddCTA()} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleChildPCData}>{t("sideNav.newJobRequest.ok")}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default ChildProcessCostModal;